import { useTranslate } from '@refinedev/core';
import { Tag } from 'antd';

const statusColors: Record<string, string> = {
  enabled: 'green',
  disabled: 'red',
  test: 'orange',
};

interface ModStatusTagProps {
  value?: string | null;
}

export const ModStatusTag = ({ value }: ModStatusTagProps) => {
  const t = useTranslate();
  return (
    <Tag color={statusColors[value ?? ''] ?? 'default'}>
      {value ? t(`base.mod_status.${value}`) : '-'}
    </Tag>
  );
};
